export enum PushNotificationType {
  NEW_TRANSACTION_CREATED = 'NEW_TRANSACTION_CREATED',
  SENT_FROM_PLATFORM_OWNER = 'SENT_FROM_PLATFORM_OWNER',
  NEW_ACTIVATION_FEE_TRANSACTION = 'NEW_ACTIVATION_FEE_TRANSACTION',
  NEW_DIRECT_TRANSACTION = 'NEW_DIRECT_TRANSACTION',
  NEW_EFISCAL_TRANSACTION = 'NEW_EFISCAL_TRANSACTION',
  NEW_REFUND_TRANSACTION = 'NEW_REFUND_TRANSACTION',
  NEW_POS_TRANSACTION = 'NEW_POS_TRANSACTION',
  DUPLICATED_BILL_SCAN = 'DUPLICATED_BILL_SCAN',
  CLAIM_STATUS_CHANGE = 'CLAIM_STATUS_CHANGE',
  NEW_CLAIM_MESSAGE = 'NEW_CLAIM_MESSAGE',
  NEW_ANNOUNCEMENT = 'NEW_ANNOUNCEMENT',
  APP_VERSION_BUMP = 'APP_VERSION_BUMP',
}

export const PushNotificationOptions = [
  {
    id: PushNotificationType.APP_VERSION_BUMP,
    name: 'Nova verzija aplikacije',
  },
  {
    id: PushNotificationType.NEW_ANNOUNCEMENT,
    name: 'Obaveštenje',
  },
];
